/*
 * @Author: yanghailong 
 * @Date: 2023-08-23 09:06:46 
 * @Last Modified by: yanghailong
 * @Last Modified time: 2023-08-24 08:32:56
 */
class Record {
	constructor(topology) {
		this.id = - 1
		this.type = ''
		this.name = ''
		this.topology = topology
	}

	get storage() {
		return this.topology.storage
	}

	toJSON() {
		const output = {}
		output.type = this.type
		output.id = this.id
		output.name = this.name
		return output

	}

	fromJSON(json) {
		this.type = json.type
		this.id = json.id
		this.name = json.name
	}

}


class SetPositionRecord extends Record {
	constructor(topology, object, newPosition, optionalOldPosition) {
		super(topology)

		this.type = 'SetPosition'
		this.name = 'Set Position'

		this.object = object

		this.newPosition = Object.assign({}, newPosition)
    this.oldPosition = Object.assign({ x: 0, y: 0 }, optionalOldPosition)
	}
	execute() {
		this.object.absolutePosition(this.newPosition)
	}
	undo() {
		this.object.absolutePosition(this.oldPosition)
	}
}

class AddObjectRecord extends Record {
	constructor(topology, object) {
		super(topology)

		this.type = 'AddObject'
		this.object = object

		if (object !== undefined) {
			this.name = `Add Object: ${object.name}`;
		}
	}

	execute() {
		this.storage.addElement(this.object)
		this.storage.select(this.object)
	}
	undo() {
		this.storage.removeElement(this.object)
		this.storage.deselect()
	}
}


class RemoveObjectRecord extends Record {
	constructor(topology, object) {
		super(topology)

		this.type = 'RemoveObject'
		this.name = 'Remove Object'


		this.object = object
	}
	execute() {
		this.storage.removeElement(this.object)
		this.storage.deselect()

	}
	undo() {
		this.storage.addElement(this.object)
		this.storage.select(this.object)
	}
}



export {
	SetPositionRecord,
	AddObjectRecord,
	RemoveObjectRecord,
}
